import { getCurrentManufacturer, createCurrentManufacturer, updateCurrentManufacturer  } from "../../api/manufacturerFirebase";

export const Types = {
    LOAD: 'manufacturer/LOAD',
    ADD: 'manufacturer/ADD',
    SEARCH: 'manufacturer/SEARCH',
    REMOVE: 'manufacturer/REMOVE',
    ERROR: 'manufacturer/ERROR',
    UPDATE: 'manufacturer/UPDATE',
}

const INITIAL_STATE = {
    type: null,
    data: null,
    loading: false,
    error: null,
};

export default function manufacturer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.LOAD:
            return { ...state, type: action.type, loading: true };
        case Types.ADD: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.SEARCH: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.REMOVE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        case Types.ERROR: {
            return {
                ...state,
                type: action.type,
                loading: false,
                error: action.payload
            }
        }
        case Types.UPDATE: {
            return {
                ...state,
                type: action.type,
                data: action.payload,
                loading: false,
                error: false,
            }
        }
        default:
            return state;
    }
}

const loading = () => {
    return {
        type: Types.LOAD,
    };
}

const createManufacturer = (data) => {
    return {
        type: Types.ADD,
        payload: data
    }
}

const getManufacturer = (data) => {
    return {
        type: Types.SEARCH,
        payload: data
    }
}

const updateManufacturer = (data) => {
    return {
        type: Types.UPDATE,
        payload: data
    }
}

export const Creators = {
    createManufacturer: ({ Id, ...manufacturer }) => {
        return(dispatch) => {
            dispatch(loading())
            createCurrentManufacturer(manufacturer, (res) => {
                dispatch(createManufacturer(res))
            })
        };
    },

    updateManufacturer: (manufacturer) => {
        return (dispatch) => {
            dispatch(loading())
            updateCurrentManufacturer(manufacturer.Id, manufacturer, (res) => {
                dispatch(updateManufacturer(res))
            })
        }; 
    },

    getManufacturer: () => {
        return (dispatch) => {
            dispatch(loading())
            getCurrentManufacturer((res) => {
                dispatch(getManufacturer(res))
            })
        };
    },
}
